// Service worker registration (vite-plugin-pwa): the game opens offline after the first visit,
// and offers a calm «Actualizar» when a new version is ready instead of reloading by surprise.
import { registerSW } from 'virtual:pwa-register';
import { ICONS } from './ui/icons';
import type { Notices } from './ui/notice';

export function registerOffline(notices: Notices, opts: { readonly quiet: boolean }): void {
  if (!('serviceWorker' in navigator)) return;
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (opts.quiet) return;
      notices.show({
        text: 'Hay una versión nueva de Islora.',
        icon: ICONS.arrowsClockwise,
        action: {
          label: 'Actualizar',
          onClick: () => {
            void updateSW(true);
          },
        },
      });
    },
    onOfflineReady() {
      if (opts.quiet) return;
      notices.show({ text: 'Islora ya funciona sin conexión.', tone: 'ok', icon: ICONS.wifiSlash, duration: 4000 });
    },
  });
}
